import styled from 'styled-components';
import { detailsBackground, outlineGray } from '../../config/colors';

export const CharacteristicsWrapper = styled.ul`
  background-color: ${detailsBackground};
  padding-left: 15px;
  padding-top: 15px;
  padding-right: 45px;
  padding-bottom: 5px;
  margin-top: 5px;
  margin-bottom: 20px;
  min-height: 220px;
  border-radius: 3px;
`;

export const CharacteristicsItemWrapper = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  :not(last-of-type) {
    margin-bottom: 5px;
  }
`;

export const CharacteristicsKey = styled.p`
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  -webkit-box-orient: vertical;
  flex: 1;
`;

export const CharacteristicsValueInput = styled.input`
  width: 40%;
  height: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  font-size: 1rem;
  border: 2px solid ${outlineGray};
  flex: 2;
`;

export const CharacteristicsUnit = styled.div`
  font-size: 0.8rem;
  margin-left:1em;
  flex: 1;
`;
